import States from '../helpers/states';
import RafManager from '../helpers/raf-manager';
// import Scroll from '../helpers/scroll';
// import WebGLCanvas from '../webgl/webgl-canvas';
// import testFS from '../webgl/shaders/test.frag';

import Component from '../components/component';

export const PageEvent = {
    NEXT: '__pe_next',
    PAGE_DESTROYED: '__pe_page_destroyed'
};

export default class Page extends Component {
    constructor(page, components) {
        super();

        this.dom = {
            component: page,
            page,
            scrollable: this._find('.scrollable'),
            container: this._find('.container'),
            scrollSections: this._findAll('.scroll-section')
        };

        this.Components = components;

        // this.scroll = new Scroll({
        //     direction: 'vertical',
        //     native: false,
        //     noscrollbar: false,
        //     listener: this.dom.page,
        //     section: this.dom.scrollable,
        //     sections: this.dom.scrollSections,
        //     ease: 0.1,
        //     vs: {
        //         preventTouch: true,
        //         passive: States.passive,
        //         sensibility: 1
        //     }
        // });

        // this.webGLCanvas = new WebGLCanvas({
        //     fragmentShader: testFS,
        //     uniforms: {
        //         uTexture: { type: 'sampler2D', value: this._find('img') },
        //         uTime: { type: '1f', value: 0.0 },
        //         uSpeed: { type: '1f', value: 1.0 }
        //     }
        // });
        // this.webGLCanvas.textures['uTexture'].clamp();

        bindAll(this, [
            '_update',
            '_scrollHandler',
            '_next',
            '_destroy'
        ]);

        this._showTl = new TimelineMax({ paused: true });
        this._hideTl = new TimelineMax({
            paused: true,
            onStart: () => {
                this.dom.page.style.position = 'absolute';
                this.dom.page.style.top = -getWindowPosition() + 'px';

                // Reset scroll
                document.scrollingElement.scrollTop = document.scrollingElement.scrollLeft =
                document.body.scrollTop = document.body.scrollLeft =
                document.documentElement.scrollTop = document.documentElement.scrollLeft =
                window.scrollTop = window.scrollLeft = 0;
            },
            onComplete: this._destroy
        });
    }

    _retrieveDOM() {}

    _initTls() {
        this._showTl
            .from(this.dom.page, 0.5, { autoAlpha: 0 }, 0)

        this._hideTl
            .to(this.dom.page, 0.5, { autoAlpha: 0 }, 0)
            .add(() => {
                this._next();
            }, 0)
    }

    init() {
        // if (this.scroll)
        //     this.scroll.init();
    }

    bind() {
        // RafManager.on(this._update);
        // if (this.scroll)
        //     this.scroll.on(this._scrollHandler);
    }

    unbind() {
        // RafManager.off(this._update);
        // if (this.scroll)
        //     this.scroll.off(this._scrollHandler);
    }

    show() {
        this._showTl.play();
    }

    hide() {
        this._showTl.kill();
        this._hideTl.play();
    }

    _update(delta, time) {
        // if (this.webGLCanvas) {
        //     this.webGLCanvas.setUniform('uTime', time);
        //     this.webGLCanvas.render();
        // }
    }

    _scrollHandler(currentScroll) {
    }

    resize(width = States.width, height = States.height) {
        // if (this.scroll)
        //     this.scroll.resize(width, height);

        // if (this.webGLCanvas)
        //     this.webGLCanvas.resize(width, height);
    }

    _next() {
        this.emit(PageEvent.NEXT);
    }

    _destroy() {
        // if (this.scroll)
        //     this.scroll.destroy();

        // if (this.webGLCanvas)
        //     this.webGLCanvas.destroy();

        this._next();
        this.emit(PageEvent.PAGE_DESTROYED);
    }

    _getPersitance() {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/js/pages/page.js